import { fetchWarehousesRequest, fetchWarehousesSuccess, fetchWarehousesFailed, addWarehouseRequest, addWarehouseSuccess  , addWarehouseFailed} from './actions'
import Axios from 'axios'
import keys from '../../../keys'
import store from '../../store'


export const fetchWarehouses = () => {
    return dispatch =>{
        dispatch(fetchWarehousesRequest())     
        const state = store.getState()
        Axios.get(
            `${state.entity.server}/warehouse/warehouses/`       
        )
        .then(
            result => {
            console.log(result)
               dispatch(fetchWarehousesSuccess(result.data))
            }
        )
        .catch(
            err => {
               dispatch(fetchWarehousesFailed(err))
            }
        )
    }
}


export const addWarehouse= (data) => {
    return dispatch =>{
        const state = store.getState()
        dispatch(addWarehouseRequest())     
        Axios.post(
            `${state.entity.server}/warehouse/warehouses/`, data       
        )
        .then(
            result => {
               dispatch(addWarehouseSuccess())
               dispatch(fetchWarehouses())
            }
        )
        .catch(
            err => {
               dispatch(addWarehouseFailed())
            }
        )
    }
}